import { useRBAC } from "@/hooks/useRBAC";
import type { Permission, AppSlug } from "@/types/rbac";

interface RBACGuardProps {
  permission?: Permission;
  app?: AppSlug;
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

export function RBACGuard({ permission, app, fallback = null, children }: RBACGuardProps) {
  const { can, hasApp } = useRBAC();

  if (permission && !can(permission)) return <>{fallback}</>;
  if (app && !hasApp(app)) return <>{fallback}</>;

  return <>{children}</>;
}
